import Authentication from "../Views/Authentication";
import Dashboard from "../Views/Dashboard";
import { DashboardRoutes } from "../Views/Dashboard/Constants/routes";

export const MainRoutes = [
  { Component: Authentication, path: "/auth", exact: false },
  { Component: Dashboard, path: "dashboard", exact: false, children: DashboardRoutes},
  // { Component: Dashboard,  exact: false, children: DashboardRoutes, indexRoute: true  },
];
